import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function VerifyEmail() {
  const navigate = useNavigate();
  const { updateUser } = useAuth();
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) {
      setStatus("error");
      setMessage("Lien invalide.");
      return;
    }
    api.post("/auth/verify-email", { token })
      .then((res) => {
        localStorage.setItem("ant_token", res.data.access_token);
        updateUser(res.data.user);
        setStatus("success");
        setTimeout(() => navigate("/jeu"), 1800);
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err.response?.data?.detail || "Lien invalide ou expiré.");
      });
  }, [navigate, updateUser]);

  return (
    <div className="min-h-screen grid place-items-center ant-radial px-4" data-testid="verify-email-page">
      <div className="max-w-md w-full rounded-2xl border border-[#00E676]/20 bg-[#131F17] p-8 text-center">
        <div className="font-script text-2xl text-[#39FF14] mb-4">A Nous Turf</div>
        {status === "loading" && (
          <>
            <Loader2 className="w-10 h-10 animate-spin text-[#00E676] mx-auto" />
            <p className="mt-4 text-[#A1B5A8]">Confirmation de votre compte en cours…</p>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-[#39FF14] mx-auto" />
            <h1 className="mt-4 text-2xl font-black text-white">Compte confirmé !</h1>
            <p className="mt-2 text-[#A1B5A8]">Votre email est validé. Redirection en cours…</p>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="w-12 h-12 text-[#FF3B30] mx-auto" />
            <h1 className="mt-4 text-2xl font-black text-white">Lien invalide</h1>
            <p className="mt-2 text-[#A1B5A8]">{message}</p>
            <button onClick={() => navigate("/login")} data-testid="verify-back-login" className="mt-6 w-full py-3 rounded-lg font-bold text-[#04180a] bg-gradient-to-r from-[#00E676] to-[#39FF14]">
              Retour à la connexion
            </button>
          </>
        )}
      </div>
    </div>
  );
}
